module.exports = __webpack_public_path__ + "static/img/germany-flag.cfb71af7.png";